"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRequiresLoadResource = handleRequiresLoadResource;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
async function fetchRefs(root, ids, visited, results) {
    for (const id of ids) {
        if (visited.has(id))
            continue;
        visited.add(id);
        const filePath = await (0, dist_1.findDocumentById)(root, id);
        if (!filePath)
            continue;
        const content = await fs.readFile(filePath, 'utf8');
        results.push({ id, filePath, content });
        const doc = await (0, dist_1.loadDoc)(filePath);
        if (doc.requires_load?.length) {
            await fetchRefs(root, doc.requires_load, visited, results);
        }
    }
}
async function handleRequiresLoadResource(root, uri) {
    const url = new URL(uri.replace('loom://', 'loom://host/'));
    const segments = url.pathname.replace(/^\//, '').split('/');
    // loom://requires-load/{id}  →  [requires-load, id]
    const id = segments.slice(1).join('/');
    if (!id) {
        throw new Error('loom://requires-load requires a document id: loom://requires-load/{id}');
    }
    // Primary (agent-supplied) id → suggest-on-miss. The internal requires_load
    // graph-walk in fetchRefs stays on findDocumentById: a miss there is a dangling
    // reference, not a user typo.
    const { filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
    const doc = await (0, dist_1.loadDoc)(filePath);
    const visited = new Set([id]);
    const results = [];
    await fetchRefs(root, doc.requires_load ?? [], visited, results);
    return {
        contents: [{
                uri,
                mimeType: 'application/json',
                text: JSON.stringify(results, null, 2),
            }],
    };
}
